import { useSyncExternalStore } from 'react'
import { CLOSE_GLYPHS, type CloseGlyphKind } from '@/kinds/themeprofile/schema'

export type { CloseGlyphKind }

/**
 * Which glyph the look in force gives the close button. The Shell writes it on <html> as
 * `data-close-glyph` from the resolved look (`closeGlyphOf`, lib/themeLayers.ts): a palette's own
 * or the `icons.close` slot of a studio theme. Anything not on the allowlist is the X.
 */
export const closeGlyphFor = (root: HTMLElement): CloseGlyphKind => {
  const g = root.dataset.closeGlyph
  return CLOSE_GLYPHS.find((k) => k === g) ?? 'x'
}

const subscribe = (notify: () => void) => {
  const obs = new MutationObserver(notify)
  obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-close-glyph'] })
  return () => obs.disconnect()
}
const snapshot = () => closeGlyphFor(document.documentElement)

/** A pumpkin in a 24 box, stroked in currentColor like the lucide icons beside it. */
export const Pumpkin = ({ size = 18 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    data-glyph="pumpkin"
  >
    <path d="M12 8c-2-1.5-9-1.5-9 5.5 0 3.5 3 6.5 9 6.5s9-3 9-6.5C21 6.5 14 6.5 12 8Z" />
    <path d="M9 9.5c-1.5 2.5-1.5 7 .5 10M15 9.5c1.5 2.5 1.5 7-.5 10" />
    <path d="M12 8c0-2 .5-3.5 2.5-4.5" />
  </svg>
)

/** What the close button shows: the X, or the palette's own glyph. */
export const CloseGlyph = () =>
  useSyncExternalStore(subscribe, snapshot) === 'pumpkin' ? <Pumpkin /> : <>✕</>
